export const SET_MOB = 'SET_MOB'
export const UNSET_MOB = 'UNSET_MOB'
export const PUNCH_FROM_PLAYER_TO_MOB = 'PUNCH_FROM_PLAYER_TO_MOB'

